/**
 * Tiny dev-only logger. Production bundles strip these calls into no-ops via
 * Vite's dead-code elimination when `import.meta.env.DEV` is false at build
 * time. Use this instead of `console.log` anywhere you want a trace during
 * development but don't want noise in the browser console of a real user.
 */

const isDev = import.meta.env.DEV;

export const devLog = {
  info: (...args: unknown[]) => {
    if (isDev) console.log(...args);
  },
  warn: (...args: unknown[]) => {
    if (isDev) console.warn(...args);
  },
  error: (...args: unknown[]) => {
    // Errors always go to the console — in prod these reach Sentry via the
    // browser's native error capture.
    console.error(...args);
  },
};
